/* eslint-disable no-useless-catch */
const errorMiddleware = store => next => action => {
  try {
    // Gọi hàm next() để tiếp tục với hành động hiện tại

    if (action.type.endsWith('rejected')) {
      store.dispatch({
        type: 'error/setError',
        payload: action.payload,
      });
    }

    return next(action);
  } catch (error: any) {
    // Dispatch một hành động để cập nhật trạng thái lỗi trong Redux store
    store.dispatch({
      type: 'error/setError',
      payload: error.message,
    });

    throw error; // Nếu cần tái phát lỗi
  }
};

export default errorMiddleware;
